(function (global) {
    /**
     * Builder w konfiguracji przyjmuje:
     *
     * - "dhtmlx-form-config" - Konfiguracja formularza (według pola typu "settings": http://docs.dhtmlx.com/form__controls_list.html#settings)
     * - "form-config" - konfiguracja przekazywana do nowo utworzonego obiektu NS.Form.Control
     * - @TBD (do dorobienia opcje, np. "form-name")
     *
     * @param config
     * @constructor
     */
    class Builder {
        constructor(config) {
            this.init(config);
        }

        init(config) {
            this.options = new NS.Utils.OptionsResolver(config);

            this.settings = this.options.getOption("dhtmlx-form-settings", {
                "position": "label-left",
                "labelAlign": "left"
            });
            this.formConfig = this.options.getOption("form-config", {});
            this.blockPrefix = this.options.getOption("block-prefix");

            this.fields = {};
            this.bottomButtons = {};
        }

        createFullFieldName(name) {
            let fullFieldName = name;

            if (this.blockPrefix) {
                fullFieldName = this.blockPrefix + "[" + name + "]";
            }

            return fullFieldName;
        }

        /**
         * Dodanie nowego pola do formularza.
         *
         * Typy i konfiguracja, patrz: http://docs.dhtmlx.com/form__controls_list.html
         *
         * @param name
         * @param type
         * @param configuration
         * @return Builder this
         */
        addField(name, type, configuration) {
            if (this.fields[name] !== undefined) {
                console.warn("Field: " + name + " is defined twice (or more?). Be afraid.");
            }

            const fullFieldName = this.createFullFieldName(name);

            this.fields[fullFieldName] = {
                "type": type,
                "configuration": configuration
            };

            return this;
        }

        addBottomButton(label, id, configuration) {
            if (typeof this.bottomButtons[id] != "undefined") {
                console.warn("Button with id: " + id + " is defined twice (or more?). Be afraid.");
            }

            const buttonDefinition = configuration ? configuration : {};
            buttonDefinition["label"] = label;

            this.bottomButtons[id] = buttonDefinition;

            return this;
        }

        createConfiguration() {
            return new NS.Form.Configuration({
                "fields": this.fields,
                "bottomButtons": this.bottomButtons,
                "settings": this.settings
            });
        }

        createForm(dhtmlxComponent) {
            const configuration = this.createConfiguration();
            let form = null;

            if (typeof dhtmlxComponent.attachForm === "function") {
                form = dhtmlxComponent.attachForm(configuration.getDhtmlxFormConfiguration());
            }
            else if (typeof dhtmlxComponent.dhtmlxObject === "function") {
                form = dhtmlxComponent.dhtmlxObject().attachForm(configuration.getDhtmlxFormConfiguration());
            }
            else {
                throw new Error("Builder cannot create form inside given object.");
            }

            const formObjectConfiguration = this.formConfig;
            formObjectConfiguration["handlers"] = configuration.getHandlers();
            formObjectConfiguration["block-prefix"] = this.blockPrefix;

            return new NS.Form.Control(form, formObjectConfiguration);
        }
    }

    global.NS = global.NS || {};
    global.NS.Form = global.NS.Form || {};
    global.NS.Form.Builder = Builder;
})(window);
